import { useState } from "react";
import Trophy from "../../../../media/trophy.png";
import Course from '../../../../media/my_courses.png';
import Back from "../../../../media/back.png";
import Complete from '../../../../media/complete.png';
import Not_complete from '../../../../media/not_complete.png';
import Right from "../../../../media/right.png";

const UserCourseProgressDetail = ({
  data,
  openExamId,
  setOpenExamId,
  onBack,
}) => {
  if (!data) return null;

  return (
    <div style={{ marginTop: "20px" , padding: '20px', borderRadius:'24px',  border:'1px solid #e5e7eb',  backgroundColor: "#fff"}}>


      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "12px",
          alignItems: "center"
        }}
      >
        <img
          src={Course}
          alt=""
          style={{ width: 37.5, height: 37.5, marginRight: '-5px', marginTop: '-5px' }}
        />
        <h3
          title={data.course}
          style={{
            flex: 1,
            minWidth: 0,
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {data.course}
        </h3>
      <button
        onClick={onBack}
        style={{
          width: '35px',
          height: '35px',
          borderRadius: '50%',
          border: 'none',
          background: '#393939',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          lineHeight: 1,
          marginLeft:'auto',
          flexShrink: 0,
          marginTop: '-70px',
          marginRight:'-30px'
        }}
      >
        ✖
      </button>
      </div>

      <p style={{ marginBottom: "20px", marginTop: '20px' }}>
        <img
          src={Trophy}
          alt=""
          style={{ width: 30, height: 30, marginRight: '5px' }}
        />
        Progresso:{" "}
        <strong>
          {data.total_progress}
          %
        </strong>
      </p>

     
      {data.modules.map((m) => (
        <div
          key={m.id}
          style={{
            marginBottom: "20px",
            padding: "20px",
            display: "block",
            backgroundColor: "#f5f7f7",
            borderRadius: "14px"
          }}
        >
          
          <div
            style={{
              fontWeight: 600,
              fontSize: "18px",
              marginBottom: "15px",
              paddingBottom: "10px",
            }}
          >
            <span
            title={`${m.title}`}
            style={{
              maxWidth: "35vw",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
              verticalAlign: "middle"}}>
            {m.title}
            </span>
          </div>

          
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {m.lessons.map((l) => (
              <div
                key={l.id}
                style={{
                  padding: "10px 15px",
                  borderRadius: "14px",
                  background: "#fff",
                  border:'1px solid #e5e7eb'
                }}
              >
                {l.is_completed ? (
                    <img src={Complete} alt="Completato" style={{ width: '25px', height: '25px', marginRight: '5px' }} />
                  ) : (
                    <img src={Not_complete} alt="Non completato" style={{ width: '25px', height: '25px', marginRight: '5px', marginTop: '-5px' }} />
                  )}
                <span 
                title={`${l.title}`}
                style={{
                  maxWidth: "35vw",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  verticalAlign: "middle"}}>
                {l.title}
                </span>
                {l.is_completed && (
                  <div style={{ fontSize: "14px", opacity: 0.7, marginLeft: "30px" }}>
                    {new Date(l.completed_at).toLocaleString("it-IT", {
                      dateStyle: "short",
                      timeStyle: "short",
                    })}
                  </div>
                )}
              </div>
            ))}

           
            {m.exam && (
              <div
                style={{
                  padding: "10px 15px",
                  borderRadius: "14px",
                  background: "#fff",
                  border:'1px solid #e5e7eb'
                }}
              >
                
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    {m.exam.is_completed ? (
                      <img src={Complete} alt="Completato" style={{ width: '25px', height: '25px', marginRight: '5px', marginTop: '-5px' }} />
                    ) : (
                      <img src={Not_complete} alt="Non completato" style={{ width: '25px', height: '25px', marginRight: '5px', marginTop: '-5px' }} />
                    )}
                    <strong>Esame</strong>
                  </div>

                  <button
                    type="button"
                    onClick={() =>
                      setOpenExamId(
                        openExamId === m.exam.id ? null : m.exam.id
                      )
                    }
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "12px",
                      color: "#333",
                      fontWeight: 600,
                    }}
                  >
                    {openExamId === m.exam.id
                      ? <img src={Right} alt="Nascondi dettagli" style={{ width: 30, height: 30, marginRight: '-10px', transform: "rotate(-90deg)"}}/>
                      : <img src={Right} alt="Mostra dettagli" style={{ width: 30, height: 30, marginRight: '-10px', transform: "rotate(90deg)"}}/>}
                  </button>
                </div>

                
                {openExamId === m.exam.id && (
                  <div style={{ marginTop: "10px" }}>
                    {m.exam.results.length === 0 && (
                      <p style={{ fontSize: "16px" }}>
                        Nessun tentativo disponibile
                      </p>
                    )}

                    {m.exam.results.map((r) => (
                      <div
                        key={r.id}
                        style={{
                          padding: "8px 10px",
                          marginTop: "6px",
                          borderRadius: "10px",
                          background: r.passed ? "#d4edda" : "#f8d7da",
                          fontSize: "16px",
                        }}
                      >
                       <div>
                        <strong>Punteggio:</strong> {Math.round(r.score)}%
                       </div>

                        <div>
                          <strong>Esito:</strong>{" "}
                          {r.passed ? "Superato" : "Non superato"}
                        </div>

                        <div style={{ fontSize: "14px", opacity: 0.7 }}>
                          {new Date(r.submitted_at).toLocaleString("it-IT", {
                            dateStyle: "short",
                            timeStyle: "short",
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserCourseProgressDetail;